<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../javascript/locales.json"
  import { LANDING_PAGE_TO_EXTENSION } from '../../../javascript/constants/landing_pages'

  // Import file type icons
  import docxIcon from '../../../javascript/images/modules/translations/index/docx.webp'
  import docxIcon2x from '../../../javascript/images/modules/translations/index/docx@2x.webp'
  import xlsxIcon from '../../../javascript/images/modules/translations/index/xlsx.webp'
  import xlsxIcon2x from '../../../javascript/images/modules/translations/index/xlsx@2x.webp'
  import pptxIcon from '../../../javascript/images/modules/translations/index/pptx.webp'
  import pptxIcon2x from '../../../javascript/images/modules/translations/index/pptx@2x.webp'
  import keyIcon from '../../../javascript/images/modules/translations/index/key.webp'
  import keyIcon2x from '../../../javascript/images/modules/translations/index/key@2x.webp'
  import srtIcon from '../../../javascript/images/modules/translations/index/srt.webp'
  import srtIcon2x from '../../../javascript/images/modules/translations/index/srt@2x.webp'
  import mdIcon from '../../../javascript/images/modules/translations/index/md.webp'
  import mdIcon2x from '../../../javascript/images/modules/translations/index/md@2x.webp'
  import txtIcon from '../../../javascript/images/modules/translations/index/txt.webp'
  import txtIcon2x from '../../../javascript/images/modules/translations/index/txt@2x.webp'

  let { RailsApp, landing_page } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  // Helper function to strip HTML tags for aria-label
  const stripHtml = (html) => html.replace(/<[^>]*>/g, '').trim()

  const fileTypeIcons = {
    docx: { src: docxIcon, srcset: `${docxIcon} 1x, ${docxIcon2x} 2x` },
    xlsx: { src: xlsxIcon, srcset: `${xlsxIcon} 1x, ${xlsxIcon2x} 2x` },
    pptx: { src: pptxIcon, srcset: `${pptxIcon} 1x, ${pptxIcon2x} 2x` },
    key: { src: keyIcon, srcset: `${keyIcon} 1x, ${keyIcon2x} 2x` },
    srt: { src: srtIcon, srcset: `${srtIcon} 1x, ${srtIcon2x} 2x` },
    md: { src: mdIcon, srcset: `${mdIcon} 1x, ${mdIcon2x} 2x` },
    txt: { src: txtIcon, srcset: `${txtIcon} 1x, ${txtIcon2x} 2x` }
  }

  const allDocuments = [
    { type: 'docx', name: { en: 'Resume', ja: '履歴書', 'zh-CN': '简历', 'zh-TW': '履歷' } },
    { type: 'docx', name: { en: 'Contract', ja: '契約書', 'zh-CN': '合同', 'zh-TW': '合約' } },
    { type: 'pptx', name: { en: 'Annual Report', ja: '年次報告書', 'zh-CN': '年度报告', 'zh-TW': '年度報告' } },
    { type: 'docx', name: { en: 'Business Plan', ja: '事業計画書', 'zh-CN': '商业计划书', 'zh-TW': '商業計畫書' } },
    { type: 'xlsx', name: { en: 'Financial Statement', ja: '財務諸表', 'zh-CN': '财务报表', 'zh-TW': '財務報表' } },
    { type: 'pptx', name: { en: 'Sales Report', ja: '営業報告書', 'zh-CN': '销售报告', 'zh-TW': '銷售報告' } },
    { type: 'key', name: { en: 'Keynote Presentation', ja: 'Keynoteプレゼンテーション', 'zh-CN': 'Keynote演示文稿', 'zh-TW': 'Keynote簡報' } },
    { type: 'xlsx', name: { en: 'Budget', ja: '予算書', 'zh-CN': '预算表', 'zh-TW': '預算表' } },
    { type: 'docx', name: { en: 'Meeting Minutes', ja: '議事録', 'zh-CN': '会议纪要', 'zh-TW': '會議紀錄' } },
    { type: 'pptx', name: { en: 'Proposal', ja: '提案書', 'zh-CN': '提案书', 'zh-TW': '提案書' } },
    { type: 'xlsx', name: { en: 'Invoice', ja: '請求書', 'zh-CN': '发票', 'zh-TW': '發票' } },
    { type: 'srt', name: { en: 'YouTube Subtitles', ja: 'YouTube字幕', 'zh-CN': 'YouTube字幕', 'zh-TW': 'YouTube字幕' } },
    { type: 'md', name: { en: 'API Documentation', ja: 'API仕様書', 'zh-CN': 'API文档', 'zh-TW': 'API文件' } },
    { type: 'txt', name: { en: 'Notes', ja: 'メモ', 'zh-CN': '笔记', 'zh-TW': '筆記' } }
  ]

  // Filter documents based on landing_page using imported mapping
  const documents = landing_page !== 'home' && LANDING_PAGE_TO_EXTENSION[landing_page]
    ? allDocuments.filter(doc => doc.type === LANDING_PAGE_TO_EXTENSION[landing_page])
    : allDocuments
</script>

<section id="cta" class="bg-body-secondary text-center pt-5 pb-5">
  <div class="container">
    <h2 class="text-black fw-normal mb-5 text-center">
      {i18n.t('Translations.Index.sections.cta.title')}
    </h2>
    <ul class="list-unstyled d-flex flex-wrap justify-content-center gap-0 row-gap-2 column-gap-4">
      {#each documents as doc}
        <li class="d-flex align-items-center gap-1">
          <img
            class="file-type-icon"
            src="{fileTypeIcons[doc.type].src}"
            srcset="{fileTypeIcons[doc.type].srcset}"
            alt="{doc.type}"
            title="{doc.type}"
            />
          <span>{doc.name[i18n.locale]}</span>
        </li>
      {/each}
    </ul>
    <button aria-label="{stripHtml(i18n.t('Translations.Index.sections.cta.button'))}" class="elementary-btn elementary-btn-green mt-4" onclick={() => document.querySelector('section#translate')?.scrollIntoView({ behavior: 'smooth' })}>
      {@html i18n.t('Translations.Index.sections.cta.button')}
    </button>
  </div>
</section>
